import { LocationFilterValue } from '@hakimo-ui/hakimo/types';

export const DEFAULT_LOCATION_FILTER_VALUE: LocationFilterValue = {
  values: [],
  negative: false,
};
